import { lazy } from 'react';
const SearchPage = lazy(() => import(/* webpackChunkName: "search" */ '.'));
export default SearchPage;
